<template>
  <div class="c-content-gray-box">
    <div v-if="!pageInfo">
      <sc-image v-if="fields && fields.icon" :media="fields.icon" class="icon" />
    </div>
    <div v-else>
      <sc-image :media="pageInfo.icon" class="icon" />
    </div>
    <div v-if="!pageInfo" class="c-content-gray-box__content">
      <sc-rich-text v-if="fields && fields.content" :field="fields.content" />
      <div
        class="blue-box"
        v-if="
          (fields &&
            fields.blueIntro &&
            fields.blueIntro.value &&
            fields.blueIntro.value.length > 0) ||
          (fields && linksLeft && linksLeft.length > 0) ||
          (fields && linksRight && linksRight.length > 0)
        "
      >
        <sc-text
          tag="div"
          v-if="fields && fields.blueIntro"
          :field="fields.blueIntro"
          class="blue-box__intro"
        />
        <div class="blue-box__links">
          <div class="blue-box__section">
            <component
              v-for="(linksLeft, index) in $options.computed.linksLeft"
              :is="linksLeft"
              :key="`linksLeft${index}`"
            />
          </div>
          <div class="blue-box__section">
            <component
              v-for="(linksRight, index) in $options.computed.linksRight"
              :is="linksRight"
              :key="`linksRight${index}`"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <sc-rich-text :field="pageInfo.content" />
    </div>
  </div>
</template>

<script>
import { Image, RichText, Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-Content-Gray-Box',
  components: {
    ScImage: Image,
    ScRichText: RichText,
    ScText: Text,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    },
    pageInfo: {
      type: Object
    }
  },
  withPlaceholder() {
    return {
      placeholders: [
        {
          placeholder: 'jss-content-gray-box-left',
          computedPropName: 'linksLeft'
        },
        {
          placeholder: 'jss-content-gray-box-right',
          computedPropName: 'linksRight'
        }
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.c-content-gray-box {
  padding: 3rem 2rem 1rem 2rem;
  margin-bottom: 3rem;
  background: $box-gray;
  border-radius: 5px;

  @include desktop-up {
    display: flex;
    align-items: flex-start;
    padding: 3rem 5rem 1rem 5rem;
  }

  .icon {
    float: left;
    max-width: 8rem;
    margin-right: 3rem;
    margin-bottom: 0;

    @include desktop-up {
      float: none;
    }
  }

  &:deep() {
    h3 {
      @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $dark-blue);
      margin: 0.15rem 0 1.25rem 0;
      clear: none;

      @include desktop-up {
        font-size: 2.8rem;
        line-height: 3.5rem;
      }
    }

    .c-cta--secondary {
      margin-bottom: 2rem;

      &:after {
        width: 1.7rem;
        min-width: 1.7rem;
        height: 1.3rem;
        min-height: 1.3rem;
      }
    }
  }

  .blue-box {
    margin: 3rem 0;
    padding: 2rem 3rem 2rem 3rem;
    background: linear-gradient(
      169deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 59, 92, 1) 20%,
      rgba(0, 134, 191, 1) 100%
    );
    border-radius: 5px;

    @include desktop-up {
      padding: 3rem 4rem 2rem 4rem;
    }

    &__intro {
      @include font-styles('Arial', 1.6rem, 100, normal, 2rem, 0, $white);
      position: relative;
      padding-left: 1rem;
      margin-bottom: 1rem;
      margin-left: -1rem;

      @include desktop-up {
        @include font-styles('Arial', 2rem, 100, normal, 2.6rem, 0, $white);
      }

      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 0.2rem;
        height: 100%;
        background-color: $orange;
      }
    }

    &:deep() {
      .c-cta--tertiary {
        font-weight: 400;
        line-height: 2.2rem;
        color: $white;
        padding: 0;
        margin-bottom: 2rem;

        &:hover {
          color: $white;
        }

        &:after {
          background-image: url(~@/assets/images/icon-arrow-right-white-mobile.svg);
          background-repeat: no-repeat;
          background-size: contain;
          width: 1.7rem;
          min-width: 1.7rem;
          height: 1.3rem;
          min-height: 1.3rem;
        }
      }
    }

    .blue-box__links {
      @include desktop-up {
        display: flex;
      }

      .blue-box__section {
        @include desktop-up {
          width: 50%;
        }

        &:first-child {
          @include desktop-up {
            padding-right: 2rem;
          }
        }
      }
    }

    &:deep() {
      .blue-box__section:first-child div:first-child a {
        margin-top: 2rem;
      }

      .blue-box__section div:first-child a:first-child {
        @include desktop-up {
          margin-top: 2rem;
        }
      }
    }
  }
}
</style>
